(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-json.js', './ktor-ktor-client-core.js', './ktor-ktor-serialization-kotlinx-json.js', './ktor-ktor-client-content-negotiation.js', './kotlinx-coroutines-core.js', './ktor-ktor-http.js', './fixers-f2-f2-dsl-f2-dsl-function.js', './fixers-f2-f2-client-f2-client-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-serialization-kotlinx-json.js'), require('./ktor-ktor-client-content-negotiation.js'), require('./kotlinx-coroutines-core.js'), require('./ktor-ktor-http.js'), require('./fixers-f2-f2-dsl-f2-dsl-function.js'), require('./fixers-f2-f2-client-f2-client-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'.");
    }
    if (typeof this['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'.");
    }
    if (typeof this['ktor-ktor-serialization-kotlinx-json'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'. Its dependency 'ktor-ktor-serialization-kotlinx-json' was not found. Please, check whether 'ktor-ktor-serialization-kotlinx-json' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'.");
    }
    if (typeof this['ktor-ktor-client-content-negotiation'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'. Its dependency 'ktor-ktor-client-content-negotiation' was not found. Please, check whether 'ktor-ktor-client-content-negotiation' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'.");
    }
    if (typeof this['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-function'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-function' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-function' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'.");
    }
    if (typeof this['fixers-f2-f2-client-f2-client-core'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'. Its dependency 'fixers-f2-f2-client-f2-client-core' was not found. Please, check whether 'fixers-f2-f2-client-f2-client-core' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'.");
    }
    root['fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'] = factory(typeof this['fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'] === 'undefined' ? {} : this['fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-json'], this['ktor-ktor-client-core'], this['ktor-ktor-serialization-kotlinx-json'], this['ktor-ktor-client-content-negotiation'], this['kotlinx-coroutines-core'], this['ktor-ktor-http'], this['fixers-f2-f2-dsl-f2-dsl-function'], this['fixers-f2-f2-client-f2-client-core']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_serialization_kotlinx_json, kotlin_io_ktor_ktor_client_content_negotiation, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_http, kotlin_io_komune_f2_f2_dsl_function, kotlin_io_komune_f2_f2_client_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var VOID = kotlin_kotlin.$_$.g;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var protoOf = kotlin_kotlin.$_$.fa;
  var defineProp = kotlin_kotlin.$_$.b9;
  var classMeta = kotlin_kotlin.$_$.z8;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var getBooleanHashCode = kotlin_kotlin.$_$.f9;
  var Js_instance = kotlin_io_ktor_ktor_client_core.$_$.b;
  var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.m;
  var json = kotlin_io_ktor_ktor_serialization_kotlinx_json.$_$.a;
  var Plugin_getInstance = kotlin_io_ktor_ktor_client_content_negotiation.$_$.a;
  var CoroutineImpl = kotlin_kotlin.$_$.n8;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var isInterface = kotlin_kotlin.$_$.t9;
  var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.g;
  var url = kotlin_io_ktor_ktor_client_core.$_$.j;
  var Companion_getInstance = kotlin_io_ktor_ktor_http.$_$.f;
  var HttpStatement = kotlin_io_ktor_ktor_client_core.$_$.l;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z7;
  var body = kotlin_io_ktor_ktor_client_core.$_$.a;
  var setBody = kotlin_io_ktor_ktor_client_core.$_$.i;
  var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k;
  var promise = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i1;
  var F2Supplier = kotlin_io_komune_f2_f2_dsl_function.$_$.c;
  var F2Consumer = kotlin_io_komune_f2_f2_dsl_function.$_$.a;
  var F2ClientType_HTTP_getInstance = kotlin_io_komune_f2_f2_client_core.$_$.a;
  var NotImplementedError = kotlin_kotlin.$_$.gd;
  //endregion
  //region block: pre-declaration
  setMetadataFor(AuthRealm, 'AuthRealm', classMeta);
  setMetadataFor(AuthRealmPassword, 'AuthRealmPassword', classMeta, AuthRealm);
  setMetadataFor(AuthRealmClientSecret, 'AuthRealmClientSecret', classMeta, AuthRealm);
  setMetadataFor(HttpClientBuilder, 'HttpClientBuilder', classMeta, VOID, VOID, HttpClientBuilder);
  setMetadataFor(HttpF2Client$supplier$o$invoke$slambda, 'HttpF2Client$supplier$o$invoke$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(HttpF2Client$consumer$o$invoke$slambda, 'HttpF2Client$consumer$o$invoke$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(HttpF2Client$supplier$1, VOID, classMeta, VOID, [F2Supplier]);
  setMetadataFor(HttpF2Client$consumer$1, VOID, classMeta, VOID, [F2Consumer]);
  setMetadataFor(HttpF2Client, 'HttpF2Client', classMeta);
  //endregion
  function get_F2DefaultJson() {
    _init_properties_Json_kt__5095e0();
    return F2DefaultJson;
  }
  var F2DefaultJson;
  function F2DefaultJson$lambda($this$Json) {
    _init_properties_Json_kt__5095e0();
    $this$Json.i13_1 = true;
    $this$Json.l13_1 = true;
    $this$Json.t13_1 = true;
    $this$Json.m13_1 = true;
    $this$Json.n13_1 = false;
    $this$Json.q13_1 = false;
    $this$Json.k13_1 = true;
    $this$Json.j13_1 = false;
    return Unit_instance;
  }
  var properties_initialized_Json_kt_iojru2;
  function _init_properties_Json_kt__5095e0() {
    if (!properties_initialized_Json_kt_iojru2) {
      properties_initialized_Json_kt_iojru2 = true;
      F2DefaultJson = Json(VOID, F2DefaultJson$lambda);
    }
  }
  function AuthRealm(serverUrl, realmId, clientId, redirectUrl) {
    this.o5c_1 = serverUrl;
    this.p5c_1 = realmId;
    this.q5c_1 = clientId;
    this.r5c_1 = redirectUrl;
  }
  protoOf(AuthRealm).s5c = function () {
    return this.o5c_1;
  };
  protoOf(AuthRealm).t5c = function () {
    return this.p5c_1;
  };
  protoOf(AuthRealm).u5c = function () {
    return this.q5c_1;
  };
  protoOf(AuthRealm).k2c = function () {
    return this.r5c_1;
  };
  function AuthRealmPassword(serverUrl, realmId, redirectUrl, clientId, username, password) {
    AuthRealm.call(this, serverUrl, realmId, clientId, redirectUrl);
    this.z5c_1 = serverUrl;
    this.a5d_1 = realmId;
    this.b5d_1 = redirectUrl;
    this.c5d_1 = clientId;
    this.username = username;
    this.password = password;
  }
  protoOf(AuthRealmPassword).s5c = function () {
    return this.z5c_1;
  };
  protoOf(AuthRealmPassword).t5c = function () {
    return this.a5d_1;
  };
  protoOf(AuthRealmPassword).k2c = function () {
    return this.b5d_1;
  };
  protoOf(AuthRealmPassword).u5c = function () {
    return this.c5d_1;
  };
  protoOf(AuthRealmPassword).d5d = function () {
    return this.username;
  };
  protoOf(AuthRealmPassword).t41 = function () {
    return this.password;
  };
  protoOf(AuthRealmPassword).md = function () {
    return this.z5c_1;
  };
  protoOf(AuthRealmPassword).nd = function () {
    return this.a5d_1;
  };
  protoOf(AuthRealmPassword).s22 = function () {
    return this.b5d_1;
  };
  protoOf(AuthRealmPassword).t22 = function () {
    return this.c5d_1;
  };
  protoOf(AuthRealmPassword).s23 = function () {
    return this.username;
  };
  protoOf(AuthRealmPassword).t23 = function () {
    return this.password;
  };
  protoOf(AuthRealmPassword).e5d = function (serverUrl, realmId, redirectUrl, clientId, username, password) {
    return new AuthRealmPassword(serverUrl, realmId, redirectUrl, clientId, username, password);
  };
  protoOf(AuthRealmPassword).copy = function (serverUrl, realmId, redirectUrl, clientId, username, password, $super) {
    serverUrl = serverUrl === VOID ? this.z5c_1 : serverUrl;
    realmId = realmId === VOID ? this.a5d_1 : realmId;
    redirectUrl = redirectUrl === VOID ? this.b5d_1 : redirectUrl;
    clientId = clientId === VOID ? this.c5d_1 : clientId;
    username = username === VOID ? this.username : username;
    password = password === VOID ? this.password : password;
    return this.e5d(serverUrl, realmId, redirectUrl, clientId, username, password);
  };
  protoOf(AuthRealmPassword).toString = function () {
    return 'AuthRealmPassword(serverUrl=' + this.z5c_1 + ', realmId=' + this.a5d_1 + ', redirectUrl=' + this.b5d_1 + ', clientId=' + this.c5d_1 + ', username=' + this.username + ', password=' + this.password + ')';
  };
  protoOf(AuthRealmPassword).hashCode = function () {
    var result = getStringHashCode(this.z5c_1);
    result = imul(result, 31) + getStringHashCode(this.a5d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b5d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c5d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.username) | 0;
    result = imul(result, 31) + getStringHashCode(this.password) | 0;
    return result;
  };
  protoOf(AuthRealmPassword).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AuthRealmPassword))
      return false;
    var tmp0_other_with_cast = other instanceof AuthRealmPassword ? other : THROW_CCE();
    if (!(this.z5c_1 === tmp0_other_with_cast.z5c_1))
      return false;
    if (!(this.a5d_1 === tmp0_other_with_cast.a5d_1))
      return false;
    if (!(this.b5d_1 === tmp0_other_with_cast.b5d_1))
      return false;
    if (!(this.c5d_1 === tmp0_other_with_cast.c5d_1))
      return false;
    if (!(this.username === tmp0_other_with_cast.username))
      return false;
    if (!(this.password === tmp0_other_with_cast.password))
      return false;
    return true;
  };
  function AuthRealmClientSecret(serverUrl, realmId, clientId, redirectUrl, clientSecret, isPublic) {
    isPublic = isPublic === VOID ? false : isPublic;
    AuthRealm.call(this, serverUrl, realmId, clientId, redirectUrl);
    this.j5d_1 = serverUrl;
    this.k5d_1 = realmId;
    this.l5d_1 = clientId;
    this.m5d_1 = redirectUrl;
    this.clientSecret = clientSecret;
    this.isPublic = isPublic;
  }
  protoOf(AuthRealmClientSecret).s5c = function () {
    return this.j5d_1;
  };
  protoOf(AuthRealmClientSecret).t5c = function () {
    return this.k5d_1;
  };
  protoOf(AuthRealmClientSecret).u5c = function () {
    return this.l5d_1;
  };
  protoOf(AuthRealmClientSecret).k2c = function () {
    return this.m5d_1;
  };
  protoOf(AuthRealmClientSecret).n5d = function () {
    return this.clientSecret;
  };
  protoOf(AuthRealmClientSecret).o5d = function () {
    return this.isPublic;
  };
  protoOf(AuthRealmClientSecret).md = function () {
    return this.j5d_1;
  };
  protoOf(AuthRealmClientSecret).nd = function () {
    return this.k5d_1;
  };
  protoOf(AuthRealmClientSecret).s22 = function () {
    return this.l5d_1;
  };
  protoOf(AuthRealmClientSecret).t22 = function () {
    return this.m5d_1;
  };
  protoOf(AuthRealmClientSecret).s23 = function () {
    return this.clientSecret;
  };
  protoOf(AuthRealmClientSecret).t23 = function () {
    return this.isPublic;
  };
  protoOf(AuthRealmClientSecret).p5d = function (serverUrl, realmId, clientId, redirectUrl, clientSecret, isPublic) {
    return new AuthRealmClientSecret(serverUrl, realmId, clientId, redirectUrl, clientSecret, isPublic);
  };
  protoOf(AuthRealmClientSecret).copy = function (serverUrl, realmId, clientId, redirectUrl, clientSecret, isPublic, $super) {
    serverUrl = serverUrl === VOID ? this.j5d_1 : serverUrl;
    realmId = realmId === VOID ? this.k5d_1 : realmId;
    clientId = clientId === VOID ? this.l5d_1 : clientId;
    redirectUrl = redirectUrl === VOID ? this.m5d_1 : redirectUrl;
    clientSecret = clientSecret === VOID ? this.clientSecret : clientSecret;
    isPublic = isPublic === VOID ? this.isPublic : isPublic;
    return this.p5d(serverUrl, realmId, clientId, redirectUrl, clientSecret, isPublic);
  };
  protoOf(AuthRealmClientSecret).toString = function () {
    return 'AuthRealmClientSecret(serverUrl=' + this.j5d_1 + ', realmId=' + this.k5d_1 + ', clientId=' + this.l5d_1 + ', redirectUrl=' + this.m5d_1 + ', clientSecret=' + this.clientSecret + ', isPublic=' + this.isPublic + ')';
  };
  protoOf(AuthRealmClientSecret).hashCode = function () {
    var result = getStringHashCode(this.j5d_1);
    result = imul(result, 31) + getStringHashCode(this.k5d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l5d_1) | 0;
    result = imul(result, 31) + (this.m5d_1 == null ? 0 : getStringHashCode(this.m5d_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.clientSecret) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.isPublic) | 0;
    return result;
  };
  protoOf(AuthRealmClientSecret).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AuthRealmClientSecret))
      return false;
    var tmp0_other_with_cast = other instanceof AuthRealmClientSecret ? other : THROW_CCE();
    if (!(this.j5d_1 === tmp0_other_with_cast.j5d_1))
      return false;
    if (!(this.k5d_1 === tmp0_other_with_cast.k5d_1))
      return false;
    if (!(this.l5d_1 === tmp0_other_with_cast.l5d_1))
      return false;
    if (!(this.m5d_1 == tmp0_other_with_cast.m5d_1))
      return false;
    if (!(this.clientSecret === tmp0_other_with_cast.clientSecret))
      return false;
    if (!(this.isPublic === tmp0_other_with_cast.isPublic))
      return false;
    return true;
  };
  function httpClient($this, json) {
    var tmp = Js_instance;
    return HttpClient(tmp, HttpClientBuilder$httpClient$lambda(json));
  }
  function httpClient$default($this, json, $super) {
    json = json === VOID ? get_F2DefaultJson() : json;
    return httpClient($this, json);
  }
  function HttpClientBuilder$httpClient$lambda$lambda($json) {
    return function ($this$install) {
      json($this$install, $json);
      return Unit_instance;
    };
  }
  function HttpClientBuilder$httpClient$lambda($json) {
    return function ($this$HttpClient) {
      var tmp = Plugin_getInstance();
      $this$HttpClient.y49(tmp, HttpClientBuilder$httpClient$lambda$lambda($json));
      return Unit_instance;
    };
  }
  function HttpClientBuilder(json) {
    json = json === VOID ? get_F2DefaultJson() : json;
    this.q5d_1 = json;
  }
  protoOf(HttpClientBuilder).build = function (urlBase) {
    return new HttpF2Client(urlBase, httpClient(this, this.q5d_1));
  };
  function HttpF2Client$supplier$o$invoke$slambda(this$0, $typeInfo, resultContinuation) {
    this.z5d_1 = this$0;
    this.a5e_1 = $typeInfo;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpF2Client$supplier$o$invoke$slambda).k5e = function ($this$promise, $completion) {
    var tmp = this.i3e($this$promise, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(HttpF2Client$supplier$o$invoke$slambda).xb = function (p1, $completion) {
    return this.k5e((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpF2Client$supplier$o$invoke$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 3;
            var tmp_0 = this;
            tmp_0.c5e_1 = this.z5d_1.m5e_1;
            var tmp_1 = this;
            tmp_1.d5e_1 = this.z5d_1.l5e_1;
            var tmp_2 = this;
            tmp_2.e5e_1 = this.c5e_1;
            var tmp_3 = this;
            tmp_3.f5e_1 = this.e5e_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.d5e_1);
            tmp_4.g5e_1 = this_0;
            this.g5e_1.s48_1 = Companion_getInstance().j3x_1;
            var tmp_5 = this;
            tmp_5.h5e_1 = this.f5e_1;
            var tmp_6 = this;
            tmp_6.i5e_1 = this.g5e_1;
            this.la_1 = 1;
            suspendResult = (new HttpStatement(this.i5e_1, this.h5e_1)).i4z(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.j5e_1 = suspendResult;
            this.la_1 = 2;
            suspendResult = body(this.j5e_1, this.a5e_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 3) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpF2Client$supplier$o$invoke$slambda).i3e = function ($this$promise, completion) {
    var i = new HttpF2Client$supplier$o$invoke$slambda(this.z5d_1, this.a5e_1, completion);
    i.b5e_1 = $this$promise;
    return i;
  };
  function HttpF2Client$supplier$o$invoke$slambda_0(this$0, $typeInfo, resultContinuation) {
    var i = new HttpF2Client$supplier$o$invoke$slambda(this$0, $typeInfo, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.k5e($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function HttpF2Client$consumer$o$invoke$slambda(this$0, $cmd, $queryTypeInfo, resultContinuation) {
    this.w5e_1 = this$0;
    this.x5e_1 = $cmd;
    this.y5e_1 = $queryTypeInfo;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpF2Client$consumer$o$invoke$slambda).h3e = function ($this$promise, $completion) {
    var tmp = this.i3e($this$promise, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(HttpF2Client$consumer$o$invoke$slambda).xb = function (p1, $completion) {
    return this.h3e((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpF2Client$consumer$o$invoke$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            var tmp_0 = this;
            tmp_0.a5f_1 = this.w5e_1.m5e_1;
            var tmp_1 = this;
            tmp_1.b5f_1 = this.w5e_1.l5e_1;
            var tmp_2 = this;
            tmp_2.c5f_1 = this.a5f_1;
            var tmp_3 = this;
            tmp_3.d5f_1 = this.c5f_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.b5f_1);
            setBody(this_0, this.x5e_1, this.y5e_1);
            tmp_4.e5f_1 = this_0;
            this.e5f_1.s48_1 = Companion_getInstance().j3x_1;
            var tmp_5 = this;
            tmp_5.f5f_1 = this.d5f_1;
            var tmp_6 = this;
            tmp_6.g5f_1 = this.e5f_1;
            this.la_1 = 1;
            suspendResult = (new HttpStatement(this.g5f_1, this.f5f_1)).i4z(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpF2Client$consumer$o$invoke$slambda).i3e = function ($this$promise, completion) {
    var i = new HttpF2Client$consumer$o$invoke$slambda(this.w5e_1, this.x5e_1, this.y5e_1, completion);
    i.z5e_1 = $this$promise;
    return i;
  };
  function HttpF2Client$consumer$o$invoke$slambda_0(this$0, $cmd, $queryTypeInfo, resultContinuation) {
    var i = new HttpF2Client$consumer$o$invoke$slambda(this$0, $cmd, $queryTypeInfo, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.h3e($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function HttpF2Client$supplier$1(this$0, $typeInfo) {
    this.h5f_1 = this$0;
    this.i5f_1 = $typeInfo;
  }
  protoOf(HttpF2Client$supplier$1).invoke = function () {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, HttpF2Client$supplier$o$invoke$slambda_0(this.h5f_1, this.i5f_1, null));
  };
  function HttpF2Client$consumer$1(this$0, $queryTypeInfo) {
    this.j5f_1 = this$0;
    this.k5f_1 = $queryTypeInfo;
  }
  protoOf(HttpF2Client$consumer$1).invoke = function (cmd) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, HttpF2Client$consumer$o$invoke$slambda_0(this.j5f_1, cmd, this.k5f_1, null));
  };
  function HttpF2Client(urlBase, httpClient) {
    this.l5e_1 = urlBase;
    this.m5e_1 = httpClient;
    this.n5e_1 = F2ClientType_HTTP_getInstance();
  }
  protoOf(HttpF2Client).j21 = function () {
    return this.n5e_1;
  };
  protoOf(HttpF2Client).supplier = function (route, typeInfo) {
    return new HttpF2Client$supplier$1(this, typeInfo);
  };
  protoOf(HttpF2Client).function = function (route, queryTypeInfo, responseTypeInfo) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw new NotImplementedError('An operation is not implemented: ' + reason);
  };
  protoOf(HttpF2Client).consumer = function (route, queryTypeInfo) {
    return new HttpF2Client$consumer$1(this, queryTypeInfo);
  };
  //region block: post-declaration
  defineProp(protoOf(AuthRealm), 'serverUrl', function () {
    return this.s5c();
  });
  defineProp(protoOf(AuthRealm), 'realmId', function () {
    return this.t5c();
  });
  defineProp(protoOf(AuthRealm), 'clientId', function () {
    return this.u5c();
  });
  defineProp(protoOf(AuthRealm), 'redirectUrl', function () {
    return this.k2c();
  });
  defineProp(protoOf(HttpF2Client), 'type', function () {
    return this.j21();
  });
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$client = $f2.client || ($f2.client = {});
    var $f2$client$ktor = $f2$client.ktor || ($f2$client.ktor = {});
    var $f2$client$ktor$http = $f2$client$ktor.http || ($f2$client$ktor.http = {});
    var $f2$client$ktor$http$plugin = $f2$client$ktor$http.plugin || ($f2$client$ktor$http.plugin = {});
    var $f2$client$ktor$http$plugin$model = $f2$client$ktor$http$plugin.model || ($f2$client$ktor$http$plugin.model = {});
    $f2$client$ktor$http$plugin$model.AuthRealm = AuthRealm;
    $f2$client$ktor$http$plugin$model.AuthRealmPassword = AuthRealmPassword;
    $f2$client$ktor$http$plugin$model.AuthRealmClientSecret = AuthRealmClientSecret;
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$client = $f2.client || ($f2.client = {});
    var $f2$client$ktor = $f2$client.ktor || ($f2$client.ktor = {});
    var $f2$client$ktor$http = $f2$client$ktor.http || ($f2$client$ktor.http = {});
    $f2$client$ktor$http.HttpClientBuilder = HttpClientBuilder;
    $f2$client$ktor$http.HttpClientBuilder.httpClient$default = httpClient$default;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-http.js.map
